import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const ArrowLongDown = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M6 1.125C6.20711 1.125 6.375 1.29289 6.375 1.5L6.375 9.59467L7.60984 8.35983C7.75628 8.21339 7.99372 8.21339 8.14016 8.35983C8.28661 8.50628 8.28661 8.74372 8.14016 8.89017L6.26516 10.7652C6.11872 10.9116 5.88128 10.9116 5.73484 10.7652L3.85983 8.89017C3.71339 8.74372 3.71339 8.50628 3.85983 8.35983C4.00628 8.21339 4.24372 8.21339 4.39017 8.35983L5.625 9.59467L5.625 1.5C5.625 1.29289 5.79289 1.125 6 1.125Z"
    />
  </svg>
);

export default ArrowLongDown;
